import { dominioDemandaCirurgica } from 'config/database';

const temaQuadradoAzul = 0;
const temaComplementar = 1;
const temaDark = 2;

const temaEscolhido = temaQuadradoAzul;

const temas = [
  ['#CE4958', '#9E4958', '#9E8129', '#319E45', '#7D1FAD', '#394B9E', '#16889E', '#45AF56'],
  ['#9E8539', '#9E8539', '#52400D', '#394B9E', '#6C83EB', '#152052'],
  ['#ffffff', '#ffffff', '#111111', '#222', '#333', '#444'],
];

export const tema = {
  fervendo: temas[temaEscolhido][0],
  quente: temas[temaEscolhido][1],
  morno: temas[temaEscolhido][2],
  normal: temas[temaEscolhido][3],
  frio: temas[temaEscolhido][4],
  gelado: temas[temaEscolhido][5],
  antartida: temas[temaEscolhido][6],
  transformarDemanda: temas[temaEscolhido][7],
};

export const coresGraficos = [
  '#9C65EC',
  '#6C68F2',
  '#6991DB',
  '#68CCF2',
  '#64E8DA',
  '#EB8B5E',
  '#F27161',
  '#DB638C',
  '#EE61F2',
  '#AE5DE8',
  '#CF9D61',
  '#D9BA66',
  '#C2B865',
  '#BCD966',
  '#6DD15A',
  '#5BCF5B',
  '#5FD99A',
  '#5FC2BE',
  '#5FA6D9',
  '#5465D1',
];

export const caminhoArquivosServidor = dominioDemandaCirurgica.baseURL;
